export default __webpack_public_path__ + "static/media/tear.88448042.svg";